import React from "react";
import { iconClassByMime } from "../utils/files";


export default function Attachment({ role, attachment, mime, caption, onOpenImage }) {
    if (!attachment) return null;

    // 1) User's file echo
    if (role === "user") {
        return (
            <a href={attachment} download={caption} className="user-attachment inline-flex items-center gap-2 mt-2 px-3 py-2">
                <i className={`bi ${iconClassByMime(mime)}`} />
                <span className="truncate max-w-[16rem]">{caption}</span>
            </a>
        );
    }

    // 2) Assistant file
    if (mime?.startsWith("image/")) {
        return (
            <img
                src={attachment}
                alt={caption || "imagen"}
                className="max-w-xs rounded mt-2 cursor-pointer"
                onClick={() => onOpenImage?.(attachment, caption)}
            />
        );
    }

    return (
        <a href={attachment} download={caption} className="flex items-center gap-1 text-blue-600 underline mt-2">
            <i className={`bi ${iconClassByMime(mime)}`} /> {caption || "Documento"}
        </a>
    );
}
